import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	PdfModalComponent,
	PdfModalData,
} from '@components/pdf-modal/pdf-modal.component';
import { MatterMortgageWithAssociations } from '@models/mortgage';
import { MortgageDocumentPackage } from '@models/mortgage-document-packages';
import { STATUSES } from '@models/statuses';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';
import { CloserSyncMortgageSelectors } from '../../../closer-sync-mortgage/closer-sync-mortgage.selector';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

@Component({
	selector: 'app-closer-sync-packages',
	templateUrl: './closer-sync-packages.component.html',
	styleUrls: ['./closer-sync-packages.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncPackagesComponent {
	drawerService = inject(DrawerService);

	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@SelectSnapshot(MatterMortgagesState.getSelectedMortgage)
	mortgage: MatterMortgageWithAssociations;
	@Select(CloserSyncMortgageSelectors.getAllPackages) packages$: Observable<
		MortgageDocumentPackage[]
	>;
	public STATUSES = STATUSES;

	openPDF(_package: MortgageDocumentPackage, type: string = 'packageFile') {
		const data: PdfModalData = {
			googleSrcUrl:
				'packageFile' === type ? _package.file.path : _package.faxReceipt.url,
		};
		this.drawerService.openDrawer(PdfModalComponent, {
			data,
			title: 'Package ' + _package.packageName,
			noStyle: true,
		});
	}
}
